module.exports = __webpack_public_path__ + "static/a-dance-with-dragons-37ec923d72b8c3ab0617acce0884c0c0.jpg";